import React, { Component } from 'react'
import { Card, Image, Button, Header, Icon } from 'semantic-ui-react'
import { GetTimeAgo, OrderStatus, } from '../DashboardParts'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import Kimoto from '../Kimotos/Kimoto'
import {   EditOrderLink} from '../DashboardParts'

function DaysUntil(props) {

    var a = moment(props.dateNum);
    var b = moment();
    // var dayCount = a.diff(b, 'days');

    var dayCount = b.diff(a, 'days');
    // console.log("dayCount:"+dayCount);

    let color = 'green'

    if (dayCount > 3) {
        color = 'red'
    }

    return (
        <Card.Description>
            Due - {moment(props.dateNum).fromNow()}
        </Card.Description>
    )
}

export default class UrgentOrderCard extends Component {
    constructor(props) {
        super(props)
    }

    removeUrgencyClick = () => {
        console.log("++removeUrgencyClick");
        FbUtils.removeUrgency(this.props.user.email, this.props.order);
    }

    render() {

        const currentDesignImagePreview = this.props.order.designImageUrl
            ? (<Image src={this.props.order.designImageUrl} width='250' height='250' centered bordered shape='rounded' />)
            : (<p></p>)

        const urgentDateConst = this.props.order.urgent && this.props.order.urgentObject
            ? <Header size='tiny' color='red'>DATE REQ:{this.props.order.urgentObject.urgentRequiredDateString}</Header>
            : ""


        const urgencyReason = this.props.order.urgent && this.props.order.urgentObject.urgentReason && this.props.order.urgentObject.urgentReason != ''
            ? <Card.Meta>
                {this.props.order.urgentObject.urgentReason}
              </Card.Meta>
            :""

        return (
            <Card>
                {currentDesignImagePreview}
                <Card.Content>
                    <Card.Header>#{this.props.order.order_num}-{this.props.order.name}</Card.Header>
                    <GetTimeAgo dateNum={this.props.order.dateNum} />
                    {urgentDateConst}
                    <DaysUntil dateNum={this.props.order.urgentObject.urgentRequiredDateSec} />
                    {urgencyReason}
                    <OrderStatus status={this.props.order.status} />

                     {/* edit order button */}
                

                    {/* KIMOTO STUFF */}
                    <Kimoto user={this.props.user} order={this.props.order} />
                </Card.Content>

                <Button onClick={this.removeUrgencyClick}>REMOVE URGENCY </Button>
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/UrgentComponents/UrgentOrderCard.js